<template>
    <div class="to-top">
        <div class="to-top--displacer" v-if="!isXS" :style="scrollLockStyles">
            <div class="to-top--wrap" :style="wrapStyles">
                <transition name="trs-simple-fade">
                    <button class="to-top--button" v-if="isShown"
                            @click.prevent="requestScrollTop()">
                        <span class="to-top--text" v-text="translate('TO_TOP.LABEL')"></span>
                        <cmp-icon class="to-top--icon" symbol="chevron_right" size="x-small"></cmp-icon>
                    </button>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { toNumeral, numerals } from 'util/dom/mq';
    import { mapFilters } from 'util/vue/map-filters';
    import scrollLockHelperMixin from 'vue/mixins/scroll-lock-helper';
    import viewportBoundariesMixin from 'vue/mixins/viewport-boundaries';


    export default {
        mixins: [
            scrollLockHelperMixin,
            viewportBoundariesMixin,
        ],
        data() {
            return {
                scrollLockHelperStyleProp: 'marginRight',
            };
        },
        computed: {
            ...mapGetters(['scroll', 'viewport']),
            isXS() {
                return toNumeral(this.viewport.mq.query) < numerals.SM;
            },
            isShown() {
                if (this.isXS) {
                    return false;
                }

                return this.boundaries.el.top.isBefore.vp.top;
            },
            wrapStyles() {
                if (this.isXS) {
                    return {};
                }

                return {
                    width: `calc(50% - ${ this.scroll.scrollbarWidth / 2 }px)`,
                };
            },
        },
        methods: {
            requestScrollTop() {
                window.scrollTo(0, 0);
            },
            ...mapFilters(['translate']),
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?fc42491e